import React, { useState } from "react";
import {
  Box,
  Dialog,
  DialogActions,
  DialogContent,
  FormControl,
  InputLabel,
  TextField,
  TextareaAutosize,
  Typography,
  Card,
  CardContent,
  CardHeader,
  Chip,
  makeStyles,
  withStyles,
  Tabs,
  Tab,
} from "@material-ui/core";
import GeneralLoanForm from "./GeneralLoanForm";
import LoanDetails from "./LoanDetails";
import MoenyRepayments from "./MoenyRepayments";

const AntTabs = withStyles({
  root: {
    borderBottom: "1px solid #e8e8e8",
  },
  indicator: {
    backgroundColor: "#1890ff",
  },
})(Tabs);

const AntTab = withStyles((theme) => ({
  root: {
    minWidth: "unset !important",
    textTransform: "none",
    fontWeight: theme.typography.fontWeightRegular,
    marginRight: theme.spacing(4),
    fontFamily: [
      "-apple-system",
      "BlinkMacSystemFont",
      '"Segoe UI"',
      "Roboto",
      '"Helvetica Neue"',
      "Arial",
      "sans-serif",
      '"Apple Color Emoji"',
      '"Segoe UI Emoji"',
      '"Segoe UI Symbol"',
    ].join(","),
    "&:hover": {
      color: "#40a9ff",
      opacity: 1,
    },
    "&$selected": {
      color: "#1890ff",
      fontWeight: theme.typography.fontWeightMedium,
    },
    "&:focus": {
      color: "#40a9ff",
    },
  },
  selected: {},
}))((props) => <Tab disableRipple {...props} />);

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  padding: {
    padding: theme.spacing(3),
  },
  demo1: {
    backgroundColor: theme.palette.background.paper,
  },
}));

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`tabpanel-${index}`}
      aria-labelledby={`tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box style={{ padding: "14px 0px" }}>
          <>{children}</>
        </Box>
      )}
    </div>
  );
}

const AdminLoansNavTab = () => {
  const classes = useStyles();
  const [tabValue, setTabValue] = useState(0);

  const handleChange = (event, newValue) => {
    setTabValue(newValue);
  };

  return (
    <div className={classes.root}>
      <div className={classes.demo1}>
        <AntTabs value={tabValue} onChange={handleChange} aria-label="ant example">
          <AntTab label="General" />
          <AntTab label="Loan Details" />
          <AntTab label="Loan Repayments" />
        </AntTabs>
        <Typography className={classes.padding} />
      </div>

      <div>
        <TabPanel value={tabValue} index={0}>
            <GeneralLoanForm />
        </TabPanel>
        <TabPanel value={tabValue} index={1}>
            <LoanDetails />
        </TabPanel>
        <TabPanel value={tabValue} index={2}>
        <MoenyRepayments />
        </TabPanel>
        
      </div>
    </div>
  );
};
export default AdminLoansNavTab;
